import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Input, HostListener, ElementRef} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { take } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { NbIconModule, NbTooltipModule } from '@nebular/theme';
import { MastersService } from 'src/app/core/services/masters';
import { LocalStorage } from 'src/app/core/utils';
import { ImageCompressionService } from 'src/app/core/services/shared/image-compression.service';
import { AiUsageTrackingService } from 'src/app/core/services/ai/ai-usage-tracking.service';

@Component({
    selector: 'app-imgupload',
    templateUrl: './imgupload.component.html',
    styleUrls: ['./imgupload.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: ImguploadComponent,
            multi: true
        }
    ],
    standalone: true,
    imports: [CommonModule, TranslateModule, NbIconModule, NbTooltipModule],
})
export class ImguploadComponent implements ControlValueAccessor {
  imgUrl:string;
  file:File;
  onChange: Function
  isEdit: boolean

  @Input() image: string
  @Input() isShowDelete: boolean
	@Input() css:string;
	@Input() node:any;

  @HostListener('change', ['$event.target.files']) async emitFiles( event: FileList ) {
    const reader:FileReader = new FileReader()
    const rawFile = event && event.item(0);
    if (!rawFile) return;

    const file = await this.imageCompressionService.compressImage(rawFile);
    this.file = file;
    this.onChange(file)

    reader.onloadend = (event: any) => {
      this.imgUrl = event.target.result;
    }
    reader.readAsDataURL(this.file);
  }

	private httpClient: HttpClient;
  constructor(private host: ElementRef<HTMLInputElement>, private sanitizer: DomSanitizer,
		public mastersService: MastersService,
		handler: HttpBackend,
		public http: HttpClient,
		private localStorage: LocalStorage,
		private imageCompressionService: ImageCompressionService,
		private aiUsageTracking: AiUsageTrackingService,
	) {
		this.httpClient = new HttpClient(handler);
    this.isEdit = true
  }

  writeValue( value: string ) {
    this.imgUrl = value
  }

  registerOnChange( fn: Function ) {
    this.onChange = fn;
  }

  registerOnTouched( fn: Function ) {}

  deleteImage(){
    this.imgUrl = ''
    this.onChange('')
  }

  setDisabledState( isDisabled : boolean ) : void {
    // Antes solo cubría el disable: si el FormControl pasaba a habilitado
    // (p.ej. cuando `_applyEditorPermissions` re-habilita el form del
    // proyecto al confirmar que el usuario es editor), `isEdit` se quedaba
    // en `false` y se renderizaba el placeholder no-image SIN <input> → la
    // zona de subir imagen aparecía pero al clicar no pasaba nada.
    this.isEdit = !isDisabled;
  }

	sanitizeCss(){
		return this.sanitizer.bypassSecurityTrustStyle(this.css)
	}

	generateImage(): void {
		const body = {
			prompt: this.node.description,
			idCourse: this.node.idCourseCreation,
			idTarget: this.node.idNodeTarget,
			idElement: this.node.idOriginal,
			idElementType: 1
		};
		this.http.post<any>('ai/generate-image', body).subscribe({
			next: (response) => {
				if (response) {
					this.aiUsageTracking.trackUsage({
						usageType: 'IMAGE_GENERATION', model: null, provider: 'BACKEND_AI',
						feature: 'idea-image-generator', description: 'Generación de imagen con IA desde imgupload',
						promptTokens: null, completionTokens: null, totalTokens: null
					});
					this.localStorage.setItem('dontLoadMenu', 'true');
					window.location.reload();
				}
			},
			error: (err) => {
				console.error('Error generando imagen:', err);
			}
		});
	}

}
